<template>
  <template-layout :breadCrumbList="breadcrumbComputed">
    <div class="py-12 px-4">
      <nav class="flex justify-between items-center mb-4">
        <h1 class="text-2xl text-theme-1">ครัวเรือน</h1>
        <AddHouseHoldModal
          :addHouseholdModal="addHouseholdModal"
          @modal-value="clearValue"
        />
        <button
          class="btn btn-lg btn-primary mr-1 mb-2"
          @click="openAddHouseholdModal(true)"
          data-test="add-household-modal"
          v-if="getAllowActionByCurrRole('create-household')"
        >
          + เพิ่มครัวเรือน
        </button>
      </nav>
      <div class="grid grid-cols-12 gap-6">
        <div class="col-span-12 md:col-span-4 lg:col-span-3" v-if="getAllowActionByCurrRole('search-household')">
          <HouseholdFilter />
        </div>
        <div class="col-span-12" :class="{'md:col-span-8 lg:col-span-9': getAllowActionByCurrRole('search-household')}">
          <FilterSummary :items="filterSummaryStore" v-if="getAllowActionByCurrRole('search-household')" />
          <HouseholdDatatable :filter="filterValue" :reload-table="reloadTable"/>
        </div>
        <!-- <div v-if="isUserVT">
          <VolunteerModal />
        </div> -->
      </div>
    </div>
  </template-layout>
</template>
<script setup>
import AddHouseHoldModal from "@/components/add-house-hold-modal";
import HouseholdFilter from "@/components/filter-search/HouseholdFilter.vue";
import FilterSummary from "@/components/filter-summary/index.vue";
import HouseholdDatatable from "./Datatable.vue";
import { ref, computed, watch, reactive } from "vue";
import { useStore } from "vuex";
import TemplateLayout from "@/layouts/side-menu/Main.vue";
// import VolunteerModal from "@/components/volunteer-modal/index.vue";
import { getAllowActionByCurrRole } from "@/utils/get-roles"

const store = useStore();
const filterSummaryStore = computed(
  () => store.getters["householdFilter/getFilterSummaryArray"]
);

const filterValue = computed(
  () => store.getters["householdFilter/getFilterForApi"]
);


const addHouseholdModal = ref(false);
const reloadTable = ref(false);

const openAddHouseholdModal = (val) => {
  addHouseholdModal.value = val;
  reloadTable.value = false
};
const clearValue = (val) => {
  addHouseholdModal.value = false;
  reloadTable.value = val == "saved" ? true : false
};


const isUserVT = computed(() => {
  if (store.getters["userAuth/getUserRoleCode"] == "vt" && !localStorage.getItem("volunteerData")) {
    return true;
  } else {
    return false;
  }
});
const breadcrumbComputed = reactive([{
  name: "ครัวเรือน",
  active: true
}])


</script>

<style scoped>
</style>
